import(/* webpackMode: "eager" */ "/vercel/path0/app/[...not_found]/page.js");
